import React from "react";
import "./deleteCard.css";

const DeleteCard = ({ del, close, btn = "Delete", msg = "Are you sure you want to delete ?" }) => {
  return (
    <div className="delete-card-overlay">
      <div className="delete-card">
        <p>{msg}</p>
        <div className="action-box">
          <button onClick={del}>{btn}</button>
          <button onClick={close}>No</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCard;